import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * Generated class for the HeaderTitleComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'header-title',
  templateUrl: 'header-title.html'
})
export class HeaderTitleComponent {

  @Input() title: string = '';
  @Input() showLeftButton: boolean = false;
  @Input() showInfoButton: boolean = false;
  @Input() showSettingsButton: boolean = false;
  @Input() specialNavbar : boolean = false;
  @Input() autoSearchValue : boolean = false;
  @Input() showStoreId : boolean = false;
  @Input() subtitle : string = '';
  @Input() storeId : number;
  @Input() icon : string = '';
  @Input() isModal : boolean = false;
  @Input() resultFilteredArray : any;

  @Output() goToInfo: EventEmitter<any> = new EventEmitter();
  @Output() goBack: EventEmitter<any> = new EventEmitter();
  @Output() goToAppConfig: EventEmitter<any> = new EventEmitter();
  @Output() cancel: EventEmitter<any> = new EventEmitter();
  @Output() clearFilters: EventEmitter<any> = new EventEmitter();
  online: boolean = true;

  onGoToInfo(){
    this.goToInfo.emit();
  }

  onGoBack() {
    this.goBack.emit();
  }

  onGoToAppConfig() {
    this.goToAppConfig.emit();
  }

  onCancel() {
    this.cancel.emit();
  }

  onClearFilters() {
    this.clearFilters.emit();
  }


  constructor() {
    console.log('Hello HeaderTitleComponent Component');
  }

}



// WEBPACK FOOTER //
// ./src/components/header-title/header-title.ts